module.exports = __webpack_public_path__ + "static/media/joining_bonus.d41ed7a1.webp";